import axios from "../../config/axiosConfig";
import { getSubJobReceiveTransactionTakaNo } from './sub-job-receive-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_SUB_JOB_RECEIVE, GET_SUB_JOB_RECEIVES, SUB_JOB_RECEIVE_REQUEST, UPDATE_SUB_JOB_RECEIVE, DELETE_SUB_JOB_RECEIVE, SUB_JOB_RECEIVE_REQUEST_FAILURE } from "../types";

export const getSubJobReceives = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sub-job-receive/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SUB_JOB_RECEIVES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createSubJobReceive = (subJobReceive) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST });
      const newSubJobReceive = {
        ...subJobReceive
      };
      return axios.post("/sub-job-receive/add", newSubJobReceive,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SUB_JOB_RECEIVE, payload: response.data });
          dispatch(getSubJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_RECEIVE_REQUEST_FAILURE,
            error: "Sub Job Receive create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSubJobReceive = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.put("/sub-job-receive/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SUB_JOB_RECEIVE,
            payload: { id, data: response.data },
          });
          dispatch(getSubJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_RECEIVE_REQUEST_FAILURE,
            error: "Sub Job Receive update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSubJobReceive = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/sub-job-receive/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SUB_JOB_RECEIVE, id: id });
          dispatch(getSubJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
